// @ts-strict-ignore
export class SearchObject {
    operator?: string;
    filter: string;
    page: number;
    pageSize: number;
    sortField: string;
    sortOrder: string;
}
